import { BlockBaseLegacy } from "../decoders/ContentBlocks.types";
import { Microsite, Site } from "../decoders/Sites.types";
import * as Webapi from "../generated/webapi.g";
import { reverseRoute } from "./route";

export const getContentEyebrow = (
    site: Site,
    microsite: Microsite | undefined,
    content: Webapi.PublishRecordFragment,
    eyebrow?: Webapi.Eyebrow | null,
    showEyebrow = true,
) => {
    let onMicrosite = false;
    let microSlug = "";
    let itemUrl = "";
    let eyebrowUrl = "";
    let topicName = eyebrow?.topic_name || "";

    if (microsite && microsite.index && microsite.config) {
        onMicrosite = true;
        microSlug = microsite.index.slug;
        topicName = microsite.sections.general?.name || "";
    }

    const originIsMicrosite = getOriginIsMicrosite(site, content);

    const slug = content.slug;

    // Resolve item and eyebrow url based on render context
    if (onMicrosite) {
        itemUrl = `/featured/${microSlug}` + reverseRoute(site, "detail", { slug });
        eyebrowUrl = `/featured/${microSlug}/`;
    } else if (originIsMicrosite) {
        itemUrl = `/featured/${originIsMicrosite.slug}${reverseRoute(site, "detail", { slug })}`;
        eyebrowUrl = `/featured/${originIsMicrosite.slug}/`;
        topicName = originIsMicrosite.configByLookup?.common?.branding?.name || "";
    } else {
        itemUrl = reverseRoute(site, "detail", { slug }) || "";
        if (eyebrow?.topic) {
            eyebrowUrl = reverseRoute(site, "topic", { topic: eyebrow.topic }) || "";
        }
    }

    // Override url for external content
    if (content.payload.external_url) {
        itemUrl = content.payload.external_url;
    }

    // Hide eyebrow if specified by block config
    if (!showEyebrow) {
        eyebrowUrl = "";
        topicName = "";
    }

    return { itemUrl, eyebrowUrl, topicName };
};

export const getOriginIsMicrosite = (
    site: Site,
    content: Webapi.SitemapContentItemFragment | Webapi.PublishRecordFragment,
) => {
    let originIsMicrosite = content.payload?.publish_origin
        ? site.getMicrosite(content.payload.publish_origin)
        : undefined;

    // if publish_origin did not return a result for microsite
    // check for intersection of default_shows and content distribution
    // pick first result as winner
    if (!originIsMicrosite) {
        const intersection = site.sections.general?.default_shows?.filter(show =>
            content.subscription
                .map(sub => sub.tags)
                .flat()
                .includes(show.id),
        );
        if (intersection?.length) {
            originIsMicrosite = site.getMicrosite(intersection[0].id);
        }
    }

    return originIsMicrosite;
};

export const getBlockSchedule = (block: BlockBaseLegacy | null) => {
    if (block?.schedule?.begin && block?.schedule?.end) {
        return block.schedule as Webapi.SitesSchedule;
    } else {
        return null;
    }
};
